var map = {
	"./daily-new-designs.png": "fd61",
	"./icon-back.png": "f570",
	"./icon-search.png": "6424",
	"./icon-tab-cart-active.png": "a681",
	"./icon-tab-cart.png": "6379",
	"./icon-tab-class-active.png": "a6e1",
	"./icon-tab-class.png": "05d2",
	"./icon-tab-home-active.png": "54ec",
	"./icon-tab-home.png": "7c94",
	"./icon-tab-makcer-home-active.png": "f020",
	"./icon-tab-user-active.png": "0c6d",
	"./icon-tab-user.png": "5216",
	"./img-error.png": "741e",
	"./wan4-icon.png": "6c00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cba";